<template>
  <div class="customerSupportContainer">
    customerSupportContainer
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.customerSupportContainer{
    padding: 0;
    margin-top:40px;
    text-align:center;
    padding-bottom:80px;
}
</style>




// WEBPACK FOOTER //
// src/components/CustomerSupport.vue